import { render, staticRenderFns } from "./AddCategoryMenu.vue?vue&type=template&id=2f405e2e"
import script from "./AddCategoryMenu.vue?vue&type=script&lang=js"
export * from "./AddCategoryMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports